// Adapts an EDOS TestSpecification row into the props PackageCard expects.
const PACKAGE_ICONS = ['🧪', '💧', '❤', '🦠', '🧬', '🩺', '🧠', '🩸'];

const pickIcon = (id) => PACKAGE_ICONS[Math.abs(Number(id) || 0) % PACKAGE_ICONS.length];

export const mapApiToPackage = (p, index = 0) => {
  const mrp = Number(p.mrp) || 0;
  const sale = Number(p.l2l_price) || mrp;
  const savePct = mrp > sale && mrp > 0 ? Math.round(((mrp - sale) / mrp) * 100) : 0;
  const paramCount = p.parameters
    ? String(p.parameters).split(',').filter((s) => s.trim()).length
    : 0;

  return {
    id: p.id,
    icon: pickIcon(p.id),
    name: p.test_name,
    paramCount,
    tat: p.report_tat || '—',
    price: sale,
    original: mrp,
    savePercent: savePct ? `${savePct}%` : '0%',
    featured: index === 0,
  };
};
